// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #d0566e;
  cursor: pointer;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  height: 40px;
}
.custom-select.disabled-styling {
  cursor: not-allowed;
}
.custom-select .selected-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #3a3a3a;
  font-size: 16px;
  font-weight: 400;
  padding: 9px 0px 4px 0px;
  gap: 8px;
}
.custom-select .selected-item .select-placeholder {
  color: #aaa;
}
.custom-select .arrow-up {
  transform: rotate(-180deg);
  transition: 0.3s;
}
.custom-select .arrow-down {
  transform: rotate(0deg);
  transition: 0.3s;
}
.custom-select .options-container {
  border-radius: 5px;
  padding: 4px 0px;
  background: #fff;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.11);
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 5px;
  min-width: 100%;
  width: fit-content;
  max-height: 250px;
  overflow: auto;
  z-index: 99;
}
.custom-select .options-container .options-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.custom-select .options-container .options-list li {
  line-height: 34px;
  color: #3a3a3a;
  font-size: 14px;
  font-weight: 400;
  padding: 4px 8px;
  margin: 0 4px;
}
.custom-select .options-container .options-list li:hover {
  background: #f3f3f3;
  border-radius: 4px;
  cursor: pointer;
}
.custom-select .hide {
  display: none;
}

.custom-label {
  color: #3a3a3a;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomSelect/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,QAAA;AAAJ;AAEI;EACE,WAAA;AAAN;AAIE;EACE,0BAAA;EACA,gBAAA;AAFJ;AAKE;EACE,uBAAA;EACA,gBAAA;AAHJ;AAME;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gDAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAJJ;AAMI;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AAJN;AAMM;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAJR;AAMQ;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;AAJV;AAUE;EACE,aAAA;AARJ;;AAYA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AATF","sourcesContent":[".custom-select {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 1px solid #d0566e;\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n  height: 40px;\n\n  &.disabled-styling{\n    cursor: not-allowed;\n  }\n\n  .selected-item {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #3a3a3a;\n    font-size: 16px;\n    font-weight: 400;\n    padding: 9px 0px 4px 0px;\n    gap: 8px;\n\n    .select-placeholder {\n      color: #aaa;\n    }\n  }\n\n  .arrow-up {\n    transform: rotate(-180deg);\n    transition: 0.3s;\n  }\n\n  .arrow-down {\n    transform: rotate(0deg);\n    transition: 0.3s;\n  }\n\n  .options-container {\n    border-radius: 5px;\n    padding: 4px 0px;\n    background: #fff;\n    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.11);\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    margin-top: 5px;\n    min-width: 100%;\n    width: fit-content;\n    max-height: 250px;\n    overflow: auto;\n    z-index: 99;\n\n    .options-list {\n      list-style-type: none;\n      margin: 0;\n      padding: 0;\n\n      & li {\n        line-height: 34px;\n        color: #3a3a3a;\n        font-size: 14px;\n        font-weight: 400;\n        padding: 4px 8px;\n        margin: 0 4px;\n\n        &:hover {\n          background: #f3f3f3;\n          border-radius: 4px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  .hide {\n    display: none;\n  }\n}\n\n.custom-label {\n  color: #3a3a3a;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
